import { useMemo } from "react";
import { useLocation } from 'react-router-dom';
import theme from "../theme";

const colorSystems = {
  facebook: {
    colorMedia: 'facebook',
    mainColor: theme.palette.facebook.main,
    lightColor: theme.palette.facebook.light,
    darkColor: theme.palette.facebook.dark,
    w01Color: theme.palette.facebook.facebook01,
    pathIncludes: 'fb'
  },
  google: {
    colorMedia: 'google',
    mainColor: theme.palette.google.main,
    lightColor: theme.palette.google.light,
    darkColor: theme.palette.google.dark,
    w01Color: theme.palette.google.google01,
    pathIncludes: 'google'
  },
  line: {
    colorMedia: 'line',
    mainColor: theme.palette.line.main,
    lightColor: theme.palette.line.light,
    darkColor: theme.palette.line.dark,
    w01Color: theme.palette.line.line01,
    pathIncludes: 'line'
  },
  taboola: {
    colorMedia: 'taboola',
    mainColor: theme.palette.taboola.main,
    lightColor: theme.palette.taboola.light,
    darkColor: theme.palette.taboola.dark,
    w01Color: theme.palette.taboola.taboola01,
    pathIncludes: 'taboola'
  },
  system: {
    colorMedia: 'system',
    mainColor: theme.palette.system.main,
    lightColor: theme.palette.system.light,
    darkColor: theme.palette.system.dark,
    w01Color: theme.palette.system.w0,
    pathIncludes: ''
  }
}

const useColorSystem = () => {
  const location = useLocation();

  const colorSystem = useMemo(() => {
    const path = location.pathname;

    for (const [key, system] of Object.entries(colorSystems)) {
      if (system.pathIncludes && path.includes(system.pathIncludes)) {
        return system;
      }
    }

    return colorSystems.system;
  }, [location.pathname]);

  return colorSystem;
}

export default useColorSystem;